import React, { useEffect, useId } from "react";
import { about, aboutSvg, user1, user3, user4 } from "../../../assets";
import CeoImage from "/images/users/wahaj2.jpg";
import {
  ArrowRight,
  Facebook,
  Instagram,
  Lightbulb,
  Linkedin,
  LoaderPinwheel,
  Twitter,
} from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import {
  scrollVariantsLeft,
  scrollVariantsRight,
  upAndDown,
  downAndUp,
} from "../../../constants/TextAnimation";
import { TimelineDemo } from "../../animation/TimelineDemo";

const people = [
  {
    name: "Shelly Howe",
    role: "Head of Global Real Estate Sales",
    edu: "(MBA)",
    image: "/images/users/3.jpg",
    linkedin: "https://www.linkedin.com/in/shellyhowe",
    twitter: "https://twitter.com",
    facebook: "https://www.facebook.com",
    instagram: "https://www.instagram.com/",
  },
  {
    name: "Mohamed Khan",
    role: "Group Financial controller",
    edu: "(BA), currently pursuing CPA",
    image: user4,
    linkedin: "https://www.linkedin.com/in/muhammadkhizarkhan",
    twitter: "https://twitter.com",
    facebook: "https://www.facebook.com",
    instagram: "https://www.instagram.com/",
  },
  {
    name: "Jennifer Harding",
    role: "Creative Director",
    // edu: "(BA), currently pursuing CPA",
    image: "/images/users/Jennifer.jpg",
    // linkedin: "https://www.linkedin.com/in/muhammadkhizarkhan",
    twitter: "https://twitter.com",
    facebook: "https://www.facebook.com",
    instagram: "https://www.instagram.com/",
  },

  {
    name: "Hannah Sioco",
    role: "Marketing Manager",
    edu: "(B.Com)",
    image: "/images/users/user8.png",
    linkedin: "https://www.linkedin.com/in/hannah-sioco",
    twitter: "https://twitter.com",
    facebook: "https://www.facebook.com",
    instagram: "https://www.instagram.com/",
  },
  {
    name: "Huzaifa Ghori",
    role: "Business and Growth Strategist",
    image: "/images/users/HuzaifaGhori.jpg",
  },
];

const AboutUs = () => {
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  const navigate = useNavigate();
  return (
    <>
      {/* <section
        className="relative w-full h-screen flex items-center bg-[#061C2C] text-white overflow-hidden"
        style={{
          backgroundImage: `url(${heroBg})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "top",
          backgroundSize: "cover",
        }}
      >
        
        <div className="absolute inset-0 bg-black/65 z-0" />

        <div className="relative z-10 px-6 md:px-20 max-w-3xl">
          <h1 className="text-4xl md:text-5xl font-extrabold leading-tight mb-6">
            Comprehensive Solutions For All Your Business Needs
          </h1>
          <p className="text-base md:text-lg text-gray-300 mb-8">
            Empowering businesses with tailored solutions, expertise, and
            innovation to drive growth and unlock their full potential
          </p>
          <button className="border border-white inline-flex items-center gap-2 text-black px-6 py-3 rounded-full bg-white hover:opacity-90 transition font-medium">
            Get Started Now <MoveUpRight size={16} />
          </button>
        </div>
      </section> */}

      <section
        className="py-10 sm:py-16 md:pt-24 md:pb-20 lg:pt-36 lg:pb-24 container"
        id="mission-vision"
      >
        <div
          className="mt-5 sm:mt-0 grid grid-cols-1 lg:grid-cols-2 overflow-hidden relative bg-center bg-no-repeat bg-cover h-[106vh] lg:h-[75vh] md:h-[122vh]"
          style={{ backgroundImage: `url(${about})` }}
        >
          {/* Overlay */}
          <div className="absolute inset-0 bg-black/70 z-0" />

          <div className="flex relative items-end px-4 my-auto sm:pb-16 md:justify-center sm:px-6 lg:px-8">
            <motion.div
              initial="hidden"
              whileInView="visible"
              variants={upAndDown}
              viewport={{ amount: 0.3 }}
              className="p-3 text-left mb-4"
            >
              <h6 className="font-semibold text-white pb-8">
                <span className="relative inline-block text-white text-lg tracking-wide">
                  About Us
                  {/* Gradient underline like ::before */}
                  <span className="absolute left-1 bottom-[-0.625rem] w-full h-1 rounded-[3.125rem] bg-gradient-to-r from-secondary to-gold" />
                </span>
              </h6>
              <h3
                className="font-semibold mb-4 text-white text-2xl md:text-4xl !leading-snug"
                style={{ fontFamily: "monospace" }}
              >
                Empowering Businesses{" "}
                <span className="text-green-400">Strategically!</span>
              </h3>
              <p className="mb-8 font-normal text-white text-base leading-relaxed">
                Scan Global Holdings is a network of advisory firms dedicated to
                delivering tailored solutions that empower businesses of all
                sizes to expand and achieve their full potential. Our network
                specializes in accounting and tax advisory, business growth
                consulting, and bespoke investment advice for Startups and mid
                to large-sized businesses.
              </p>
              <Link
                to="/contact"
                className="bg-green-400 text-slate-900 font-semibold py-3 px-5 hover:bg-opacity-85 transition duration-200"
              >
                Get Started
              </Link>

              {/* <section className="flex justify-center items-center">
                <button
                  className="group flex justify-center p-2 rounded-md drop-shadow-xl bg-gradient-to-r from-gray-800 to-black text-white font-semibold hover:translate-y-3 hover:rounded-[50%] transition-all duration-500 hover:from-[#331029] hover:to-[#310413]"
                  href="/"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 15 15"
                    className="w-5"
                  >
                    <path
                      clipRule="evenodd"
                      fillRule="evenodd"
                      fill="currentColor"
                      d="M7.49933 0.25C3.49635 0.25 0.25 3.49593 0.25 7.50024C0.25 10.703 2.32715 13.4206 5.2081 14.3797C5.57084 14.446 5.70302 14.2222 5.70302 14.0299C5.70302 13.8576 5.69679 13.4019 5.69323 12.797C3.67661 13.235 3.25112 11.825 3.25112 11.825C2.92132 10.9874 2.44599 10.7644 2.44599 10.7644C1.78773 10.3149 2.49584 10.3238 2.49584 10.3238C3.22353 10.375 3.60629 11.0711 3.60629 11.0711C4.25298 12.1788 5.30335 11.8588 5.71638 11.6732C5.78225 11.205 5.96962 10.8854 6.17658 10.7043C4.56675 10.5209 2.87415 9.89918 2.87415 7.12104C2.87415 6.32925 3.15677 5.68257 3.62053 5.17563C3.54576 4.99226 3.29697 4.25521 3.69174 3.25691C3.69174 3.25691 4.30015 3.06196 5.68522 3.99973C6.26337 3.83906 6.8838 3.75895 7.50022 3.75583C8.1162 3.75895 8.73619 3.83906 9.31523 3.99973C10.6994 3.06196 11.3069 3.25691 11.3069 3.25691C11.7026 4.25521 11.4538 4.99226 11.3795 5.17563C11.8441 5.68257 12.1245 6.32925 12.1245 7.12104C12.1245 9.9063 10.4292 10.5192 8.81452 10.6985C9.07444 10.9224 9.30633 11.3648 9.30633 12.0413C9.30633 13.0102 9.29742 13.7922 9.29742 14.0299C9.29742 14.2239 9.42828 14.4496 9.79591 14.3788C12.6746 13.4179 14.75 10.7025 14.75 7.50024C14.75 3.49593 11.5036 0.25 7.49933 0.25Z"
                    />
                  </svg>
                  <span className="absolute opacity-0 group-hover:opacity-100 group-hover:text-gray-700 group-hover:text-sm group-hover:-translate-y-10 duration-700">
                    GitHub
                  </span>
                </button>
              </section> */}

              {/* <div className="inline-block bg-gradient-to-tl from-gold via-transparent to-secondary p-px rounded-xl mb-3">
                <div className="rounded-xl py-1.5 px-5 text-3xl font-bold md:text-4xl lg:text-2xl lg:leading-tight bg-neutral-900">
                  <span className="bg-clip-text bg-gradient-to-tl from-gold to-secondary text-transparent">
                    200+
                  </span>
                </div>
              </div> */}
            </motion.div>
          </div>

          <motion.div
            initial="hidden"
            whileInView="visible"
            variants={downAndUp}
            viewport={{ amount: 0.3 }}
            className="flex relative items-center justify-center px-4 py-10 sm:px-6 lg:px-8 sm:py-16 lg:py-20"
          >
            <img src={aboutSvg} alt="about svg" className="object-cover" />
          </motion.div>
        </div>
      </section>

      {/* our statement */}
      <section className="py-8 sm:py-16 lg:pt-16 lg:pb-16 container">
        <motion.h6
          initial="hidden"
          whileInView="visible"
          variants={scrollVariantsRight}
          viewport={{ amount: 0.3 }}
          className="font-semibold text-white pb-8"
        >
          <span className="relative inline-block text-white text-lg tracking-wide">
            Our Statements
            {/* Gradient underline like ::before */}
            <span className="absolute left-1 bottom-[-0.625rem] w-full h-1 rounded-[3.125rem] bg-gradient-to-r from-secondary to-gold" />
          </span>
        </motion.h6>
        {/* Card Grid */}

        <motion.div
          initial="hidden"
          whileInView="visible"
          variants={scrollVariantsLeft}
          viewport={{ amount: 0.3 }}
          className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-center divide-y lg:divide-y-0 lg:divide-x divide-neutral-700 "
        >
          <div
            className="group relative rounded-xl  border border-neutral-700 z-10 p-4 md:p-6 h-full flex flex-col bg-neutral-900 focus:outline-hidden  before:absolute before:inset-0 before:bg-gradient-to-b hover:before:from-transparent hover:before:via-transparent hover:before:to-gold/10 before:via-80% focus:before:from-transparent focus:before:via-transparent focus:before:to-gold/10 before:-z-1  lg:last:before:rounded-bl-none before:opacity-0 hover:before:opacity-100 focus:before:opacity-100 overflow-hidden  before:pointer-events-none"
            // href="#"
          >
            <Grid size={20} />
            <div className="mb-5">
              <LoaderPinwheel size={26} className="text-secondary" />

              <div className="mt-5">
                <p className="font-semibold text-5xl text-white">43%</p>
                <h3 className="mt-5 font-medium text-lg text-white">Mission</h3>
                <p className="mt-1 text-neutral-400">
                  We strive to be a trusted partner in business transformation
                  by delivering bespoke consulting strategies that inspire
                  growth, optimize performance, and create lasting value.
                </p>
              </div>
            </div>
            <p className="mt-auto">
              <Link
                to="#story"
                onClick={(e) => {
                  e.preventDefault(); // Prevent default hash jump
                  const el = document.getElementById("story");
                  if (el) {
                    el.scrollIntoView({ behavior: "smooth" });
                  }
                }}
                className="font-medium text-sm text-gold inline-flex gap-1 items-center pb-1 border-b-2 border-neutral-700 group-hover:border-gold group-focus:border-gold transition focus:outline-hidden"
              >
                Read more <ArrowRight size={15} />
              </Link>
            </p>
          </div>

          <div
            className="group relative rounded-xl  before:pointer-events-none  border border-neutral-700 z-10 p-4 md:p-6 h-full flex flex-col bg-neutral-900 focus:outline-hidden  before:absolute before:inset-0 before:bg-gradient-to-b hover:before:from-transparent hover:before:via-transparent hover:before:to-gold/10 before:via-80% focus:before:from-transparent focus:before:via-transparent focus:before:to-gold/10 before:-z-1  lg:last:before:rounded-bl-none before:opacity-0 hover:before:opacity-100 focus:before:opacity-100 overflow-hidden"

            // href="#"
          >
            <Grid size={20} />
            <div className="mb-5">
              <Lightbulb size={34} className="text-secondary" />

              <div className="mt-5">
                <p className="font-semibold text-5xl text-white">20%</p>
                <h3 className="mt-5 font-medium text-lg text-white">Vision</h3>
                <p className="mt-1 text-neutral-400">
                  Our vision is to drive business success by providing
                  innovative, tailored consulting strategies that unlock
                  potential, inspire growth, and create lasting impact.
                </p>
              </div>
            </div>
            <p className="mt-auto">
              <Link
                to="#story"
                onClick={(e) => {
                  e.preventDefault(); // Prevent default hash jump
                  const el = document.getElementById("story");
                  if (el) {
                    el.scrollIntoView({ behavior: "smooth" });
                  }
                }}
                className="font-medium text-sm text-gold inline-flex gap-1 items-center pb-1 border-b-2 border-neutral-700 group-hover:border-gold group-focus:border-gold transition focus:outline-hidden"
              >
                Read more <ArrowRight size={15} />
              </Link>
            </p>
          </div>

          {/* Card */}
          {/* <Link
              className="group relative z-10 p-4 md:p-6 h-full flex flex-col bg-neutral-900 focus:outline-hidden first:rounded-t-xl last:rounded-b-xl lg:first:rounded-l-xl lg:first:rounded-tr-none lg:last:rounded-r-xl lg:last:rounded-bl-none before:absolute before:inset-0 before:bg-gradient-to-b hover:before:from-transparent hover:before:via-transparent hover:before:to-[#ff0]/10 before:via-80% focus:before:from-transparent focus:before:via-transparent focus:before:to-[#ff0]/10 before:-z-1 last:before:rounded-b-xl lg:first:before:rounded-s-xl lg:last:before:rounded-e-xl lg:last:before:rounded-bl-none before:opacity-0 hover:before:opacity-100 focus:before:opacity-100"
              href="#"
            >
              <div className="mb-5">
                <svg
                  className="shrink-0 size-8"
                  width="33"
                  height="32"
                  viewBox="0 0 33 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M32.8875 15.3054C32.9242 16.2093 32.8209 17.1099 32.5811 17.9792C32.3447 18.8486 31.9716 19.6695 31.4787 20.4141C30.989 21.1593 30.3861 21.8167 29.6935 22.3607L29.6769 22.3745L23.019 27.563L19.7451 30.1433L17.7501 31.7089C17.6335 31.8024 17.5036 31.8716 17.3671 31.9201C17.2305 31.9686 17.084 31.9929 16.9374 31.9929C16.7942 31.9929 16.6477 31.9686 16.5111 31.9201C16.3745 31.8716 16.2447 31.8024 16.1281 31.7089L14.1331 30.1433L10.8591 27.563L4.24125 22.4057L4.20129 22.378L4.18796 22.3641C3.49187 21.8203 2.88904 21.1623 2.39611 20.4176C1.90319 19.6729 1.53016 18.8486 1.29036 17.9792C1.05056 17.1099 0.947313 16.2059 0.98395 15.3019C1.02392 14.3979 1.20044 13.5078 1.51018 12.6626L1.55348 12.5414L5.90654 0.747936C5.92875 0.69021 5.95539 0.634792 5.98648 0.581684C6.01534 0.528576 6.04976 0.478931 6.08972 0.43275C6.12747 0.38426 6.16855 0.339234 6.21295 0.297671C6.25736 0.258417 6.30399 0.221472 6.35284 0.186836C6.45609 0.121028 6.56267 0.0725381 6.67924 0.0448295C6.79248 0.0136573 6.91238 -0.000196993 7.02895 0.00673016C7.14885 0.0136573 7.26542 0.0379024 7.37533 0.0829289C7.48524 0.124492 7.59181 0.186836 7.68507 0.263035C7.72948 0.302289 7.77278 0.343852 7.81496 0.387724C7.85493 0.433905 7.89046 0.483549 7.92154 0.536658C7.95485 0.587457 7.98371 0.641719 8.00814 0.699446C8.03256 0.754863 8.05254 0.812589 8.06809 0.872625L11.0023 10.2139H22.8792L25.8134 0.872625C25.8289 0.812589 25.85 0.754863 25.8767 0.699446C25.9011 0.644029 25.93 0.589766 25.9633 0.536658C25.9944 0.485858 26.0299 0.437368 26.0699 0.391187C26.1098 0.345006 26.1531 0.302289 26.1997 0.263035C26.293 0.186836 26.3962 0.127955 26.5062 0.0829289C26.6194 0.0413659 26.736 0.0171209 26.8525 0.0101937C26.9724 0.00326659 27.089 0.0136573 27.2056 0.0448295C27.3188 0.0760017 27.4287 0.124492 27.5286 0.1903C27.5797 0.222627 27.6275 0.259571 27.6719 0.301134C27.7163 0.340388 27.7573 0.38426 27.7951 0.43275C27.8328 0.48124 27.8673 0.532039 27.8983 0.585148C27.9272 0.638256 27.9527 0.693673 27.9749 0.751399L32.3213 12.5483L32.3646 12.6696C32.6744 13.5112 32.8509 14.4014 32.8875 15.3054Z"
                    fill="#E24329"
                  />
                  <path
                    d="M32.8909 15.309C32.9275 16.2095 32.8243 17.1135 32.5845 17.9829C32.3447 18.8523 31.9717 19.6766 31.4787 20.4213C30.9858 21.1659 30.383 21.824 29.6902 22.3678L29.6736 22.3816L23.0157 27.5701C23.0157 27.5701 20.1881 25.3499 16.9374 22.7903L26.4795 15.2813C26.9092 14.9453 27.3588 14.6371 27.8218 14.3531C28.2847 14.0656 28.7643 13.8093 29.2539 13.5807C29.7468 13.3521 30.2498 13.1477 30.7593 12.978C31.2722 12.8049 31.7918 12.6628 32.3214 12.5485L32.3647 12.6698C32.6744 13.5149 32.8509 14.405 32.8909 15.309Z"
                    fill="#FC6D26"
                  />
                  <path
                    d="M16.9374 22.7903C20.1881 25.343 23.0191 27.5701 23.0191 27.5701L19.7451 30.1504L17.7501 31.716C17.6335 31.8095 17.5036 31.8788 17.3671 31.9273C17.2305 31.9758 17.084 32 16.9374 32C16.7942 32 16.6477 31.9758 16.5111 31.9273C16.3746 31.8788 16.2447 31.8095 16.1281 31.716L14.1331 30.1504L10.8591 27.5701C10.8591 27.5701 13.6868 25.343 16.9374 22.7903Z"
                    fill="#FCA326"
                  />
                  <path
                    d="M16.9374 22.7834C13.6834 25.343 10.8591 27.5632 10.8591 27.5632L4.24125 22.4059L4.20129 22.3782L4.18796 22.3643C3.49187 21.8205 2.88904 21.1625 2.39611 20.4178C1.90319 19.6731 1.53016 18.8488 1.29036 17.9794C1.05056 17.1101 0.947313 16.2061 0.98395 15.3021C1.02392 14.3981 1.20044 13.508 1.51018 12.6628L1.55348 12.5416C2.08304 12.6559 2.60261 12.7979 3.11552 12.9711C3.6251 13.1443 4.12801 13.3452 4.62094 13.5772C5.11053 13.8058 5.59014 14.0656 6.05309 14.3496C6.51604 14.6336 6.96233 14.9453 7.39531 15.2813L16.9374 22.7834Z"
                    fill="#FC6D26"
                  />
                </svg>

                <div className="mt-5">
                  <p className="font-semibold text-5xl text-white">12%</p>
                  <h3 className="mt-5 font-medium text-lg text-white">
                    Streamlining Development
                  </h3>
                  <p className="mt-1 text-neutral-400">
                    {" "}
                    With the goal of accelerating project delivery and enhancing
                    collaboration among development teams, Preline leveraged
                    GitLab's comprehensive Office of tools and Preline's expertise
                    in digital product development.
                  </p>
                </div>
              </div>
              <p className="mt-auto">
                <span className="font-medium text-sm text-[#ff0] pb-1 border-b-2 border-neutral-700 group-hover:border-[#ff0] group-focus:border-[#ff0] transition focus:outline-hidden">
                  Read more
                </span>
              </p>
            </Link> */}
          {/* End Card */}
        </motion.div>
        {/* End Card Grid */}
      </section>

      {/* our success */}
      <section className="py-4  sm:pb-14 lg:pb-18">
        <div className="container">
          {/* Icon Blocks */}
          <div className="max-w-[85rem] px-4 py-6 sm:px-6 lg:px-8 lg:py-14 mx-auto">
            {/* Grid */}
            <div className="grid md:grid-cols-2 gap-12">
              {/* left side */}
              <motion.div
                initial="hidden"
                whileInView="visible"
                variants={scrollVariantsRight}
                viewport={{ amount: 0.3 }}
                className="lg:w-3/4"
              >
                <h6 className="font-semibold text-white pb-8">
                  <span className="relative inline-block text-white text-2xl font-bold lg:text-5xl tracking-wide">
                    What Drives Our Success?
                    {/* Gradient underline like ::before */}
                    <span className="absolute left-1 bottom-[-0.625rem] w-full h-1 rounded-[3.125rem] bg-gradient-to-r from-secondary to-gold" />
                  </span>
                </h6>
                <p className="mt-3 text-lg text-neutral-400">
                  Strategic Synergy, Amplified Success
                </p>
                <p className="mt-5">
                  <Link
                    className="inline-flex items-center gap-x-1 text-sm text-gold decoration-2 hover:underline focus:outline-hidden focus:underline font-medium "
                    to="/contact"
                  >
                    Contact to learn more
                    <svg
                      className="shrink-0 size-4 transition ease-in-out group-hover:translate-x-1 group-focus:translate-x-1"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="m9 18 6-6-6-6" />
                    </svg>
                  </Link>
                </p>
              </motion.div>

              {/* right side */}
              <motion.div
                initial="hidden"
                whileInView="visible"
                variants={scrollVariantsLeft}
                viewport={{ amount: 0.3 }}
                className="flex gap-x-2 sm:gap-x-6"
              >
                {/* Icon */}
                <span className="shrink-0 inline-flex justify-center items-center size-11 rounded-full border shadow-2xs mx-auto bg-neutral-900 border-neutral-700 text-neutral-200">
                  <svg
                    className="shrink-0 size-5"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M7 10v12" />
                    <path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2h0a3.13 3.13 0 0 1 3 3.88Z" />
                  </svg>
                </span>
                <div className="grow">
                  <h3 className="text-base sm:text-lg font-semibold text-neutral-200">
                    Simple and affordable
                  </h3>
                  <p className="mt-1 text-neutral-400">
                    At Scan Global Holdings, we serve as a strategic backbone
                    for our network, ensuring they benefit from collective
                    expertise, financial oversight, and operational support. By
                    partnering with Centres of Influence—industry leaders,
                    advisors, and strategic partners—we amplify opportunities
                    for our businesses and clients. This interconnected approach
                    ensures our subsidiaries and stakeholders thrive in a
                    competitive market.
                  </p>
                </div>
              </motion.div>
            </div>
            {/* End Grid */}
          </div>
          {/* End Icon Blocks */}
        </div>
      </section>

      {/* our story */}
      <section className="py-6  sm:pb-10 lg:pb-18" id="story">
        <div className="container">
          <TimelineDemo />
        </div>
      </section>

      {/* our team */}
      <section className="py-6 relative sm:pb-16 lg:pb-28" id="team">
        {/* Top right curved line */}
        <div className="absolute top-20 right-20 hidden lg:block">
          <svg
            width="150"
            height="150"
            viewBox="0 0 150 150"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M30,10 Q80,20 120,80"
              stroke="#c5ae7a"
              strokeWidth="2"
              fill="none"
            />
          </svg>
        </div>

        {/* Left side curved line */}
        <div className="absolute left-10 top-1/3 hidden lg:block">
          <svg
            width="150"
            height="300"
            viewBox="0 0 150 300"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M30,50 Q60,150 30,250"
              stroke="#c5ae7a"
              strokeWidth="2"
              fill="none"
            />
          </svg>
        </div>

        {/* Small square */}
        <div className="absolute top-20 right-40 hidden lg:block">
          <div className="w-6 h-6 border-2 border-gold transform rotate-45"></div>
        </div>

        {/* Abstract shape */}
        {/* <div className="absolute top-1/2 right-1/4 hidden lg:block">
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M10,10 L30,10 L20,30 Z" fill="#c5ae7a" />
          </svg>
        </div> */}

        {/* Scribble lines */}
        <div className="absolute top-1/4 right-1/5 hidden lg:block">
          <svg
            width="100"
            height="60"
            viewBox="0 0 100 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10,30 Q20,10 30,30 Q40,50 50,30 Q60,10 70,30 Q80,50 90,30"
              stroke="#fff"
              strokeWidth="1"
            />
          </svg>
        </div>
        <div className="container">
          <div className="px-4 mx-auto sm:px-6 lg:px-8">
            <motion.div
              variants={downAndUp}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.5 }}
              className="max-w-2xl mx-auto text-center"
            >
              <h2 className="text-3xl font-bold leading-tight  sm:text-3xl lg:text-4xl">
                Meet Our Team
              </h2>
              <p className="max-w-lg mx-auto mt-4 text-base lg:text-lg leading-normal text-gray-400">
                A dynamic group of experts working together to achieve great
                results through passion and collaboration.
              </p>
            </motion.div>
          </div>

          <main className="container mx-auto px-4 py-12">
            <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
              <div className="md:col-span-5 relative">
                <div className="md:sticky md:top-24">
                  <div className="relative group">
                    <div className="relative border-4 border-white shadow-lg bg-white max-w-xs mx-auto h-full">
                      <img
                        src={CeoImage}
                        alt="Profile"
                        className="w-full h-full lg:h-[400px] object-cover"
                      />
                      <div className="absolute top-0 right-0 transform translate-x-3 -translate-y-2">
                        <div className="w-6 h-6 rounded-full bg-gold animate-pulse"></div>
                      </div>
                      <div className="absolute right-0 bottom-0 w-2 bg-gold h-16"></div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="md:col-span-7">
                <div className="px-4 sm:p-8">
                  {/* <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold mb-8">
                    About Me<span className="text-black">.</span>
                  </h1> */}

                  <h6 className="text-4xl sm:text-5xl md:text-6xl font-bold mb-8">
                    <span className="relative inline-block text-white text-3xl font-bold lg:text-4xl tracking-wide">
                      Founder and CEO
                      {/* Gradient underline like ::before */}
                      <span className="absolute left-1 bottom-[-0.625rem] w-full h-1 rounded-[3.125rem] bg-gradient-to-r from-secondary to-gold" />
                    </span>
                  </h6>

                  <div className="text-2xl md:text-5xl font-bold ">
                    Wahaj Ahmed{" "}
                    <span className="block md:inline text-xs md:text-sm text-white/70 font-semibold mb-4 ">
                      CPA, CGA (Canada), FCCA (UK)
                    </span>
                  </div>

                  <p className="text-[14px] md:text-xl text-white/90 font-semibold mb-8 inline-flex items-center gap-6 whitespace-nowrap">
                    <span>CEO and Founder, Scan Global Holdings</span>
                    <Link
                      target="_blank"
                      rel="noopener noreferrer"
                      to="https://www.linkedin.com/in/wahaja/"
                    >
                      <Linkedin
                        // color="#fff"
                        size={38}
                        className="border-white/20 p-2 rounded-xl bg-gold hover:bg-opacity-85 transition-all duration-200 text-slate-900 border"
                      />
                    </Link>
                  </p>

                  <div className="max-w-2xl">
                    <div className="mb-6 flex items-center">
                      <div className="w-12 h-0.5 bg-white mr-4"></div>
                      <p className="text-sm sm:text-base text-gray-200">
                        “ Bringing 15+ years of experience in controlling all
                        aspects of corporate accounting and financial reporting
                        functions of various Fortune 500 Organizations and Top
                        10 global accounting firms. Wahaj leads with extensive
                        experience in global{" "}
                        <span className="font-bold">
                          Business Advisory and Real Estate.
                        </span>
                      </p>
                    </div>

                    <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-8">
                      <div className="relative pl-6 border-l-2 border-gray-600">
                        <div className="absolute left-0 top-1.5 w-3 h-3 bg-gray-400 rounded-full transform -translate-x-1.5"></div>
                        <h3 className="font-medium mb-2">
                          Discovery & Insight
                        </h3>
                        <p className="text-gray-400">
                          Every partnership begins with understanding. Through
                          an in-depth consultation, Wahaj and his team identify
                          the client’s goals, challenges, and long-term vision.
                          This stage focuses on clarity uncovering true needs
                          and opportunities that may lie beyond the surface.
                        </p>
                      </div>

                      <div className="relative pl-6 border-l-2 border-gray-600">
                        <div className="absolute left-0 top-1.5 w-3 h-3 bg-gray-400 rounded-full transform -translate-x-1.5"></div>
                        <h3 className="font-medium mb-2">
                          Strategic Design & Resource Alignment
                        </h3>
                        <p className="text-gray-400">
                          Once clarity is achieved, Team Scan orchestrates the
                          right people, tools, and strategies. This is where
                          innovation meets structure where customized solutions
                          are crafted and aligned to combine core strengths to
                          design bespoke solutions in business growth, and
                          investment strategy.
                        </p>
                      </div>

                      <div className="relative pl-6 border-l-2 border-gray-600">
                        <div className="absolute left-0 top-1.5 w-3 h-3 bg-gray-400 rounded-full transform -translate-x-1.5"></div>
                        <h3 className="font-medium mb-2">
                          Integration & Growth
                        </h3>
                        <p className="text-gray-400">
                          In the final phase, every element comes together.
                          Wahaj and his team ensure execution with precision,
                          building exceptional cross-disciplinary collaboration
                          across Business Brokerage, CFO & Financial Solutions,
                          and Advisory Services and real estate. Clients leave
                          not just with results, but with a holistic strategy
                          for continued expansion.{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>

          <div
            // initial="hidden"
            // whileInView="visible"
            // variants={upAndDown}
            // viewport={{ amount: 0.3 }}
            className="grid grid-cols-1 lg:grid-cols-3 gap-4 lg:gap-6 pt-10 px-6 lg:px-16"
          >
            {people.map((item, key) => (
              <motion.div
                key={key}
                initial="hidden"
                whileInView="visible"
                variants={upAndDown}
                viewport={{ amount: 0.3 }}
                className="group relative overflow-hidden border border-x-white/5 shadow-lg transition-transform duration-300 ease-in-out hover:-translate-y-2 before:absolute before:inset-0 before:-z-10 before:bg-slate-900 before:opacity-0 before:transition-opacity before:duration-300 hover:before:opacity-100 cursor-pointer"
              >
                <div className="block relative -mb-32 before:bg-slate-900 before:absolute before:w-full before:h-full">
                  <img
                    src="/images/lines.svg"
                    alt="img"
                    className="w-full h-32"
                  />{" "}
                </div>
                <div className="p-4">
                  <div className="justify-center text-center relative ">
                    <Link className="relative inline-block mt-8" href="#">
                      <img
                        src={item.image}
                        className="w-32 h-32 object-cover rounded-full ring-4 ring-gray-100 mx-auto ring-white/10"
                        alt="user-img"
                      />
                    </Link>
                    <div className="space-y-2">
                      <div className="mt-4">
                        <h2 className="font-semibold text-xl">{item.name}</h2>
                        <p className="text-sm text-white/70">{item.edu}</p>
                      </div>
                      <span className="max-w-[12rem] truncate whitespace-nowrap inline-block py-1.5 px-3 rounded-sm text-xs font-medium bg-gold/10 text-gold">
                        {item.role}
                      </span>
                    </div>
                    <div className="flex justify-center items-center gap-6 pt-5">
                      {/* <Link
                        target="_blank"
                        rel="noopener noreferrer"
                        to={item.linkedin}
                      >
                        <Linkedin
                          color="#fff"
                          size={38}
                          className="border-white/20 p-2 rounded-xl hover:bg-slate-950  border"
                        />
                      </Link> */}

                      {/* <Link
                          target="_blank"
                          rel="noopener noreferrer"
                          to={item.instagram}
                        >
                          <Instagram
                            color="#fff"
                            size={38}
                            className="border-white/20 p-2 rounded-xl hover:bg-slate-950  border"
                          />
                        </Link>
                        <Link
                          target="_blank"
                          rel="noopener noreferrer"
                          to={item.twitter}
                        >
                          <Twitter
                            color="#fff"
                            size={38}
                            className="border-white/20 p-2 rounded-xl hover:bg-slate-950  border"
                          />
                        </Link>
                        <Link
                          target="_blank"
                          rel="noopener noreferrer"
                          to={item.facebook}
                        >
                          <Facebook
                            color="#fff"
                            size={38}
                            className="border-white/20 p-2 rounded-xl hover:bg-slate-950  border"
                          />
                        </Link> */}
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutUs;

export const Grid = ({ pattern, size }) => {
  const p = pattern ?? [
    [Math.floor(Math.random() * 4) + 7, Math.floor(Math.random() * 6) + 1],
    [Math.floor(Math.random() * 4) + 7, Math.floor(Math.random() * 6) + 1],
    [Math.floor(Math.random() * 4) + 7, Math.floor(Math.random() * 6) + 1],
    [Math.floor(Math.random() * 4) + 7, Math.floor(Math.random() * 6) + 1],
    [Math.floor(Math.random() * 4) + 7, Math.floor(Math.random() * 6) + 1],
  ];
  return (
    <div className="pointer-events-none absolute left-1/2 top-0  -ml-20 -mt-2 h-full w-full [mask-image:linear-gradient(white,transparent)]">
      <div className="absolute inset-0 bg-gradient-to-r  [mask-image:radial-gradient(farthest-side_at_top,white,transparent)] from-zinc-900/30  to-zinc-900/30 opacity-100">
        <GridPattern
          width={size ?? 20}
          height={size ?? 20}
          x="-12"
          y="4"
          squares={p}
          className="absolute inset-0 h-full w-full  mix-blend-overlay fill-white/10 stroke-white/10 stroke-black/10 fill-black/10"
        />
      </div>
    </div>
  );
};

export function GridPattern({ width, height, x, y, squares, ...props }) {
  const patternId = useId();

  return (
    <svg aria-hidden="true" {...props}>
      <defs>
        <pattern
          id={patternId}
          width={width}
          height={height}
          patternUnits="userSpaceOnUse"
          x={x}
          y={y}
        >
          <path d={`M.5 ${height}V.5H${width}`} fill="none" />
        </pattern>
      </defs>
      <rect
        width="100%"
        height="100%"
        strokeWidth={0}
        fill={`url(#${patternId})`}
      />
      {squares && (
        <svg x={x} y={y} className="overflow-visible">
          {squares.map(([x, y], idx) => (
            <rect
              strokeWidth="0"
              key={`${x}-${y}-${idx}`}
              width={width + 1}
              height={height + 1}
              x={x * width}
              y={y * height}
            />
          ))}
        </svg>
      )}
    </svg>
  );
}
